import {Injectable} from '@angular/core';

import {HttpClient, HttpEvent, HttpHeaders} from '@angular/common/http';

import {User} from '../models/user';
import {Observable} from 'rxjs';
import {Permission} from '../models/permission';
import {AssignRoleToUser} from '../models/assign-role-to-user';

import {BaseService} from '../../../services/base.service';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {


    httpOptions;

    constructor(private authService: AuthService, private httpClient: HttpClient) {

        super();
    }

    // get users list
    public getUsers(): Observable<User[]> {

        return this.httpClient.get<User[]>(`${this.apiURL}/users`, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get users list
    public getUsersByRole(roles_shortnames): Observable<User[]> {

        const obj = {
            'role_shortnames': roles_shortnames
        };
        return this.httpClient.post<User[]>(`${this.apiURL}/users/byrole`, obj, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get users list
    public getUsersByPermission(permission): Observable<User[]> {

        const obj = {
            'permission_name': permission
        };
        return this.httpClient.post<User[]>(`${this.apiURL}/users/byperm`, obj, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get searched users list
    public getSearchedUsers(keyword): Observable<User[]> {

        return this.httpClient.get<User[]>(`${this.apiURL}/users/search/` + keyword, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get searched users list
    public quickSearchedUsers(keyword): Observable<User[]> {

        return this.httpClient.get<User[]>(`${this.apiURL}/users/qsearch/` + keyword, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get user by id
    public getUser(id): Observable<User> {

        return this.httpClient.get<User>(`${this.apiURL}/users/` + id,
            {headers: this.authService.getHttpOptions()}
        );

    }

    // get user permissions user by id
    public getUserPermissions(id): Observable<Permission[]> {

        return this.httpClient.get<Permission[]>(`${this.apiURL}/users/permissions/` + id, {
            headers: this.authService.getHttpOptions()
        });

    }


    // add user
    public addUser(user: User) {

        return this.httpClient.post<any>(`${this.apiURL}/users`, user, {
            headers: this.authService.getHttpOptions()
        });

    }

    // upload User Picture
    public uploadUserPicture() {

        return this.httpClient.post<any>(`${this.apiURL}/user/avatar`, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get User Picture
    public getUserPicture(id) {

        return this.httpClient.get(`${this.apiURL}/user/avatar/` + id,
            {headers: this.authService.getHttpOptions()}
        );

    }

    // assign role to user
    public assignRoleToUser(obj: AssignRoleToUser) {

        return this.httpClient.post<any>(`${this.apiURL}/user/role/assign`, obj, {
            headers: this.authService.getHttpOptions()
        });

    }

    // unAssign role from user
    public unAssignRoleToUser(obj: AssignRoleToUser) {

        return this.httpClient.post<any>(`${this.apiURL}/user/role/unassign`, obj, {
            headers: this.authService.getHttpOptions()
        });

    }

    // update user
    public updateUser(user: User) {

        return this.httpClient.put<any>(`${this.apiURL}/users`, user, {
            headers: this.authService.getHttpOptions()
        });

    }

    // delete user
    public removeUser(id) {

        return this.httpClient.delete<any>(`${this.apiURL}/users/` + id, {
            headers: this.authService.getHttpOptions()
        });

    }


}
